import React from "react";
import { psdaLogo } from "@tvet-mis/psda-assets";
import { OptimizedSvg } from "../common/OptimizedSvg";

const SidebarLogo: React.FC = () => (
	<div className="p-4 mb-6">
		<OptimizedSvg
			width="20rem"
			height="8rem"
			src={psdaLogo}
			alt="PSDA Logo"
			className="sidebar-logo"
			cacheKey="psda-logo"
		/>
	</div>
);

export default SidebarLogo;
